import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService } from '../core/services/auth.service';
import { UkrDateTimeComponent } from '../design-system/ukr-date-time/ukr-date-time.component';
import { PageHeaderComponent } from '../design-system/page-header/page-header.component';

@Component({
    selector: 'app-profile',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        CardModule,
        TagModule,
        DividerModule,
        ProgressSpinnerModule,
        UkrDateTimeComponent,
        PageHeaderComponent,
    ],
    templateUrl: './profile.html',
    styleUrls: ['./profile.css']
})
export class ProfileComponent {
    private authService = inject(AuthService);
    currentUser = this.authService.currentUser;

    avatarInitials = computed(() => {
        const user = this.currentUser();
        if (user?.employee?.surname && user?.employee?.name) {
            return (user.employee.surname[0] + user.employee.name[0]).toUpperCase();
        }
        return (user?.employee?.name?.[0] || user?.email?.[0] || '?').toUpperCase();
    });
}
